import { useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MovieCard from '@/components/feature/MovieCard';
import { categories, featuredMovies, latestUpdates } from '@/mocks/siteData';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];

  const allMovies = [...featuredMovies, ...latestUpdates];
  const filteredMovies = slug
    ? allMovies.filter((m) => m.category === slug)
    : allMovies;

  const breadcrumbList = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.tianmeimahua.com/' },
      { '@type': 'ListItem', position: 2, name: currentCategory.name, item: `https://www.tianmeimahua.com/category/${slug}` },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbList) }} />
      <Navbar />
      <main className="pt-20 md:pt-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
            <span>/</span>
            <span className="text-foreground-900 font-medium">{currentCategory.name}</span>
          </nav>

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {currentCategory.name}
            </h1>
            <p className="mt-2 text-sm text-foreground-600">{currentCategory.description}</p>
          </div>

          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredMovies.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {filteredMovies.map((movie) => (
                <MovieCard
                  key={movie.id}
                  id={movie.id}
                  title={movie.title}
                  category={movie.category}
                  rating={movie.rating}
                  imageUrl={movie.imageUrl}
                  tags={'tags' in movie ? movie.tags : undefined}
                  episode={'episode' in movie ? movie.episode : undefined}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-500">暂无相关内容</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}